export default __webpack_public_path__ + "static/media/business-model-zoo-3.b2e935f3.svg";